module.exports = __webpack_public_path__ + "img/Webb-Bridge-Melbourne-Drawing-effect.36ac6548.svg";